import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ClearIcon from '@mui/icons-material/Clear';

export default function ProjectsLoadsList(props){
    //console.debug("RTS Break ProjectLoadsList")

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const formatObj = new Intl.DateTimeFormat("en-US");    


    function handleClick(e, cellValues){
        props.removeLoadFx(cellValues.row);
    }

    
    const columns = [
        {
            field: 'curAliasName', 
            headerName: "Product", 
            description:"Southwire Product Id", 
            flex:3,
        },
        {
            field: 'reelTypeName', 
            headerName: "Reel Type", 
            description:"Reel Type", 
            flex:2,
            hideable:false,
        },  
        {
            field: 'curReelSerialNumber', 
            headerName: "Reel", 
            description:"Reel Serial Number", 
            flex:2,
            hideable:false,
        },  
        {
            field: 'shipDate', 
            headerName: "Purchase Date", 
            description:"Reel Ship Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    formatObj.format(new Date(value))
                );
            }, 
        },
        {
            field: '',
            description:"Remove Reel", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                                <ClearIcon sx={{color:"red"}} />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },        
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {shipDate:false}
        }
        else{
            return {}
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <Box sx={{display:'flex', flexDirection:'column', width:'100%', minHeight:'300px'}}>        
            <DataGridPro
                disableColumnFilter
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },                        
                    }
                }}                
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    density: getDensity() 
                }}                
            />
        </Box>        



    );
}
